<span class="ql-formats">
    <select class="ql-header">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option selected>Normal</option>
    </select>
</span>
<span class="ql-formats">
    <button class="ql-bold" aria-label="Bold" type="button"></button>
    <button class="ql-italic" aria-label="Italic" type="button"></button>
    <button class="ql-underline" aria-label="Underline" type="button"></button>
    <button class="ql-strike" aria-label="Strikeout" type="button"></button>
</span>
<span class="ql-formats">
    <select class="ql-color"></select>
    <select class="ql-background"></select>
</span>
<span class="ql-formats">
    <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
    <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
    <select class="ql-align">
        <option selected></option>
        <option value="center">center</option>
        <option value="right">right</option>
        <option value="justify">justify</option>
    </select>
</span>
<span class="ql-formats">
    <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
</span>
